module.exports = __webpack_public_path__ + "static/2front-design-2-56c28dfd5b68701a93d3a103d902067b.png";